module.exports = __webpack_public_path__ + "img/art11.e46dd654.png";